const { io } = require('socket.io-client')

const socket = io('https://api.krludo.in', {
  transports: ['websocket']
})

socket.on('connect_error', () => {
  socket.io.opts.transports = ['polling', 'websocket']
})
export default socket
